/** The project status vocabulary. Nothing on this platform may imply funding or delivery it does not have. */
export const STATUSES = {
  verified: ["Existing and verified", "border-emerald-500/60 text-emerald-300"],
  proposed: ["Proposed", "border-zinc-600 text-zinc-300"],
  development: ["In development", "border-sky-500/60 text-sky-300"],
  funded: ["Funded", "border-ochre text-ochre"],
  construction: ["Under construction", "border-amber-500/60 text-amber-300"],
  operational: ["Operational", "border-maasai text-maasai"],
};

export const StatusTag = ({ status, testId }) => {
  const [label, tone] = STATUSES[status] || STATUSES.proposed;
  return (
    <span
      data-testid={testId || `status-${status}`}
      className={`mono inline-block border px-2.5 py-1 text-[0.5rem] font-bold uppercase tracking-[0.16em] ${tone}`}
    >
      {label}
    </span>
  );
};

export const StatusKey = () => (
  <div className="flex flex-wrap gap-2" data-testid="status-key">
    {Object.keys(STATUSES).map((k) => (
      <StatusTag key={k} status={k} testId={`status-key-${k}`} />
    ))}
  </div>
);
